<div *ngIf="loaderService.isLoading | async" class="rcg-loader-container">
    <rcg-loader [mode]="brand"></rcg-loader>
</div>
<ng-content></ng-content>
